/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./FinancialPreQualification.module.css";

const BenefitCard = ({ iconSrc, title, description }) => {
    return (
        <div className={`${styles.benefitCard} tw-max-h-[170px] tw-min-w-[300px] tw-gap-4 lg:tw-h-fit tw-border-1`}>
            <div className="tw-w-fit  tw-p-4 tw-bg-background_color tw-rounded-full">
                <img loading="lazy" src={iconSrc} alt="" className={`${styles.benefitIcon}   `} />
            </div>
            <div className="tw-text-start tw-w-[75%]">
                <h3 className={`${styles.benefitTitle}  tw-leading-4`}>{title}</h3>
                <p className={`${styles.benefitDescription} tw-leading-5`}>{description}</p>
            </div>
        </div>
    );
};

export default BenefitCard;
